module.exports = __webpack_public_path__ + "img/25_66.5933dea2.png";